export const titleColor = '#A79468'
export const navbarColor = '#2F3643'
export const orGradient = { backgroundImage: 'linear-gradient(90deg,'+titleColor+',#E1CD8D' }
export const orBg = { backgroundColor: '#A79468' }

//F1E3B4 Trop clair ?
//D7C27D, E1CD8D Bonne couleur/un peu clair
//C7B371 Bonne couleur
